@if (availableGroups; as items) {
  <form [formGroup]="blendedCurveForm" (ngSubmit)="saveBlendedCurve()">
    <aux-modal primaryButtonType="submit" [loading]="loading()">
      <div class="w-screen max-w-[330px]"></div>

      <div class="mb-4 text-xs font-bold">{{ subTitle }}</div>

      @for (item of items; track item; let index = $index) {
        <div class="mb-4 text-sm">
          <aux-checkbox
            class="mb-3 text-sm"
            [checked]="item.check"
            (customChange)="setValue(item, $event)"
          >
            {{ item.name }}
          </aux-checkbox>
        </div>
      }

      <div class="grid text-sm">
        <aux-input
          formControlName="blendedCurveName"
          [validators]="validators"
          [label]="'Blended Curve Name'"
          [showRequiredAsterisk]="true"
        />
      </div>
    </aux-modal>
  </form>
}
